import { ChangeDetectionStrategy, Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { UntilDestroy } from '@ngneat/until-destroy';

export interface SelectOption<T> {
  key: T;
  value: string;
}

@UntilDestroy()
@Component({
  selector: 'app-common-single-selector',
  templateUrl: './common-single-selector.component.html',
  styleUrls: ['./common-single-selector.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => CommonSingleSelector),
    },
  ],
})
export class CommonSingleSelector<T> implements ControlValueAccessor {
  @Input() public options: SelectOption<T>[] = [];
  @Input() public label?: string;
  @Input() public placeholder?: string;

  public formControl = new FormControl<T | undefined>(undefined, { nonNullable: true });
  public trackByValue = (_: number, item: SelectOption<T>): string => item.value;

  public onChange: (value: T | undefined) => void = () => {};
  public onTouched = () => {};

  public writeValue(value: T | undefined): void {
    this.formControl.setValue(value);
    this.onChange(value);
    this.onTouched();
  }

  public registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
}
